import { ZodFormattedError, z } from 'zod'
import { proposalApiBaseUrl } from './proposal-api-url'

// List each var statically: passing the whole import.meta.env would inline every VITE_* var into the bundle.
const viteEnv = {
  VITE_PROPOSAL_API_BASE_URL: import.meta.env.VITE_PROPOSAL_API_BASE_URL,
  VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  VITE_TENANT_ID: import.meta.env.VITE_TENANT_ID,
  VITE_API_SCOPE: import.meta.env.VITE_API_SCOPE,
  VITE_APPINSIGHTS_CONNECTION_STRING: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING,
}

export const isSandbox =
  window.location.ancestorOrigins?.item(0)?.includes('sandbox') || window.location.href.includes('&sandbox=true')

export const isDev =
  window.location.ancestorOrigins?.item(0)?.includes('dev') || window.location.href.includes('&dev=true')

export type DynamicsEnvironment = 'dev' | 'sandbox' | 'prod'
export const dynamicsEnvironment: DynamicsEnvironment = isDev ? 'dev' : isSandbox ? 'sandbox' : 'prod'

// export const isMaintenanceMode = !window.location.href.includes('&disableMaintenance=true')
export const isMaintenanceMode = false

// Dynamics URLs are deterministic per environment — no build-time secrets needed
const DYNAMICS_URLS = {
  dev: { base: 'https://daisycodev.crm.dynamics.com', api: 'https://daisycodev.api.crm.dynamics.com' },
  sandbox: { base: 'https://daisycosandbox.crm.dynamics.com', api: 'https://daisycosandbox.api.crm.dynamics.com' },
  prod: { base: 'https://daisyco.crm.dynamics.com', api: 'https://daisyco.api.crm.dynamics.com' },
} as const

const parsedEnvResult = z
  .object({
    VITE_PROPOSAL_API_BASE_URL: z.string(),
    VITE_CLIENT_ID: z.string(),
    VITE_TENANT_ID: z.string(),
    VITE_API_SCOPE: z.string(),
    VITE_APPINSIGHTS_CONNECTION_STRING: z.string().optional(),
  })
  .safeParse(viteEnv)

export const formatErrors = (errors: ZodFormattedError<Map<string, string>, string>) => {
  return Object.entries(errors)
    .map(([name, value]) => {
      if (value && '_errors' in value) return `${name}: ${value._errors.join(', ')}\n`
    })
    .filter(Boolean)
}

if (!parsedEnvResult.success) {
  console.error('❌ Invalid environment variables:\n', ...formatErrors(parsedEnvResult.error.format()))
  throw new Error('Invalid environment variables')
}

export const env = {
  ...parsedEnvResult.data,
  VITE_PROPOSAL_API_BASE_URL: proposalApiBaseUrl(dynamicsEnvironment, parsedEnvResult.data.VITE_PROPOSAL_API_BASE_URL),
  VITE_DYNAMICS_BASE_URL: DYNAMICS_URLS[dynamicsEnvironment].base,
  VITE_DYNAMICS_API_BASE_URL: DYNAMICS_URLS[dynamicsEnvironment].api,
}
